module.exports = __webpack_public_path__ + "static/media/founder-special.93c2641f.png";